import React from 'react'
import Link from 'gatsby-link'

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';

import Name from './Name/Name.js';

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  
  render(){
    return (
      <div>
        <Navbar color="info" dark style={{ padding: 10 }} expand="md">
          <NavbarBrand className="mr-auto ml-5">
            <Link to="/" className="text-primary">
              Isuru Nanayakkara
              {/* <Name /> */}
            </Link>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <Link to="/" className="text-light text-lowercase">ipnanayakkara@crimson.ua.edu</Link>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js